import crudActions from '../../crud/actions'

const actions = crudActions('HR_ALLERGY_')

export default actions
